define("shared/components/shared/post/secondary/hashtag-suggestions/modal-footer", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalFooter">
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{@isDisabled}}
      @onClick={{@insertHashtags}}
      @text={{t "hashtag_suggestions.insert" count=@numberOfSelectedHashtags}}
      class="qa--postmodal_htSubmit"
    />
    <Shared::Ui::Button
      @additional="block"
      @onClick={{@toggle}}
      @text={{t "shared_words.done"}}
      @variant="outline"
      class="qa--postmodal_htDone"
    />
  </div>
  */
  {
    "id": "pyCiqso/",
    "block": "[[[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"qa--postmodal_htSubmit\"]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@text\"],[\"block\",[30,1],[30,2],[28,[37,1],[\"hashtag_suggestions.insert\"],[[\"count\"],[[30,3]]]]]],null],[1,\"\\n  \"],[8,[39,0],[[24,0,\"qa--postmodal_htDone\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,4],[28,[37,1],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n\"],[13]],[\"@isDisabled\",\"@insertHashtags\",\"@numberOfSelectedHashtags\",\"@toggle\"],false,[\"shared/ui/button\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/modal-footer.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});